import StationResource from "./station.resource";

const stationModule = angular
  .module("app.resources.station", [])
  .service("Station", StationResource);

export default stationModule;



// WEBPACK FOOTER //
// ./src/resources/station/station.module.js